import { render, staticRenderFns } from "./ContentFilters.vue?vue&type=template&id=140a5b2d&scoped=true&"
import script from "./ContentFilters.vue?vue&type=script&lang=js&"
export * from "./ContentFilters.vue?vue&type=script&lang=js&"
import style0 from "./ContentFilters.vue?vue&type=style&index=0&id=140a5b2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a5b2d",
  null
  
)

export default component.exports